'use strict'

import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import alertmodal from './alertmodal.js'

const config = require('AppConfig')

/**
 * firebase認証機能関連の
 * 共通処理クラス
 */
class FbAuth {
    /**
     * プロバイダーに文字列「password」が含まれるかを判定
     * @returns {boolean} 含まれる場合はtrueを返却
     */
    containsPasswordInProvider = () => {
        let ret = false
        if (firebase.auth().currentUser) {
            firebase.auth().currentUser.providerData.forEach(function(profile) {
                if (profile.providerId == 'password') {
                    ret = true
                }
            })
        }
        return ret
    }

    /**
     * ログインユーザー情報を取得
     * @returns {Promise} ユーザ情報
     */
    getAuth = async () => {
        return new Promise((resolve, reject) => {
            let unsubscribe = firebase.auth().onAuthStateChanged(user => {
                unsubscribe()
                resolve(user)
            })
        })
    }

    /**
     * セッションクッキーをブラウザに設定（ログイン後処理）
     * @returns {Promise} セッションクッキー
     */
    login = async () => {
        let user = firebase.auth().currentUser
        let uid = user.uid

        //emailの確認が取れていないユーザはセッションクッキーを発行しない
        if (!user.emailVerified) {
            return Promise.resolve()
        }

        return firebase
            .firestore()
            .collection(config.collections.userData)
            .doc(uid)
            .get()
            .then(doc => {
                if (doc.exists) {
                    return firebase
                        .auth()
                        .currentUser.getIdToken(/* forceRefresh */ true)
                } else {
                    //profile未登録のユーザもセッションクッキーを発行しない
                    return Promise.reject()
                }
            })
            .then(idToken => {

                // ログイン時の計測イベントの発行
                 this.sendAnalysisLoginEvent()

                // セッションクッキー生成API
                // バックエンドログイン用のセッションクッキーの取得
                return axios.post(
                    config.api.sessionCookie,
                    {
                        idToken: idToken
                    },
                    {
                        headers: {
                            'X-From': location.href
                        }
                    }
                )
            })
            .catch(err => {
                console.log(err)
                return Promise.resolve()
            })
    }

    /**
     * ログアウト処理
     * @returns {void}
     */
    logout = async () => {
        alertmodal.setLoading()
        return new Promise((resolve, reject) => {
            let unsubscribe = firebase.auth().onAuthStateChanged(user => {
                unsubscribe()
                ;(async () => {
                    if (user) {
                        return firebase
                            .auth()
                            .signOut()
                            .then(() => {
                                return Promise.resolve()
                            })
                            .catch(err => {
                                return Promise.reject(err)
                            })
                    } else {
                        return Promise.resolve()
                    }
                })()
                    .then(() => {
                        return this.deleteSessionCookie()
                    })
                    .then(response => {
                        alertmodal.showAlert('ログアウトしました。', 'success')
                        resolve()
                    })
                    .catch(err => {
                        alertmodal.showAlert(
                            'ログアウトに失敗しました。',
                            'error'
                        )
                        reject(err)
                    })
                    .finally(() => {
                        alertmodal.removeLoading()
                    })
            })
        })
    }

    /**
     * セッションクッキー削除処理
     * @param {string} idToken idToken
     * @returns {Promise} セッションクッキー削除リクエストの戻り値
     */
    deleteSessionCookie = () => {
        return axios.post(config.api.deleteSessionCookie, null, {
            headers: {
                'X-From': location.href
            }
        })
    }

    /**
     * リダイレクトを実行
     * @param {string} redirectTo リダイレクト先のパス
     * @returns {void}
     */
    setRedirectTimer = (redirectTo = config.path.profile) => {
        // リダイレクト前にその旨を表示
        alertmodal.showAlert('画面が自動で切り替わります。', 'success')
        setInterval(function() {
            location.href = redirectTo
        }, 3000)
    }

    /**
     * ログイン時の計測イベントの発行
     * @returns {void}
     */
    sendAnalysisLoginEvent = () => {    
        if　(firebase.auth().currentUser.providerData.length ==　2)　{
            dataLayer.push({ event: 'login', 'method': ['email','facebook']})
        }　else　{
                if　(firebase.auth().currentUser.providerData[0].providerId =="password")　{
                    dataLayer.push({ event: 'login', 'method': 'email'})
                }　else　{
                    dataLayer.push({ event: 'login', 'method': 'facebook'})
                }
        }
    }
}

const fbauth = new FbAuth()
export default fbauth
